import React, { useState } from 'react';
import '../styles/Login.css';
import useAxios from '../hooks/useAxios'; // 👈 import the custom axios hook
import { useNavigate } from 'react-router-dom';
import myLogo from '../assets/images/second.jpeg';


const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const { post, loading, error } = useAxios();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess('');

    const data = await post('http://localhost:5000/api/auth/login', formData);

    if (data) {
      localStorage.setItem('token', data.token);
      setSuccess('Login successful!');
      setTimeout(() => navigate('/'), 1000); // redirect to home
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
         
           <h2 >Construction Estimation</h2>
         <img src={myLogo} className="logo-log" alt="logo" width="50" height="50" />
        <h2 className='login-heading'>Login</h2>

        {error && <p className="error">{error}</p>}
        {success && <p className="success">{success}</p>}
        {loading && <p>Logging in...</p>}

        <label>Email</label>
        <input
          type="email"
          name="email"
          className="email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <label>Password</label>
        <input
          type="password"
          name="password"
          className="password"
          value={formData.password}
          onChange={handleChange}
          required
        />

        <button className="log-submit" type="submit" disabled={loading}>Login</button>
        <p className="link-text">Don't have an account? <a href="/pages/signup">Sign Up</a></p>
        
      </form>
    </div>
  );
};

export default Login;
